import NAME from "./constants";

export const getOrgChart = store => store[NAME].orgChart;
export const getBranches = store => store[NAME].branches;
export const getCompetencyGroupList = store => store[NAME].competencyGroupList;
export const getEvaluationGroupList = store => store[NAME].evaluationGroupList;
export const getPositionClassifications = store => store[NAME].positionClassifications;
export const getLoading = store => store[NAME].gettingOrgChart || store[NAME].gettingBranchesData;
export const getPositionOccupationData = store => store[NAME].positionOccupationData;
export const getFrequencies = store => store[NAME].frequencies;
export const getResponsibilityTypes = store => store[NAME].responsibilityTypes;
export const getIntellectualRequirementTypes = store => store[NAME].intellectualRequirementTypes;
export const getPhysicalRequirementTypes = store => store[NAME].physicalRequirementTypes;
export const getWorkConditionTypes = store => store[NAME].workConditionTypes;
export const getSkillList = store => store[NAME].skillList;
export const getPeople = store => store[NAME].people;
export const getTargetList = store => store[NAME].targetList;